import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';

export class TextBoxOptions {
  /**
 * Represent Name Of Form Control
 */
  Name:string
   /**
 *   Represent classes to textbox that allow us to select the TextBox by jquery or javascript 
 */
 
  ExtraClasses:string

 /**  Represent value of the label*/
  LabelValue:string
  /**  Represent Key of the label*/
  LabelKey:string
  /**  Represent value of the labelDescription show under textbox*/
  LabelDescription:string
  /** Represent value of the Placeholder of textbox */
  Placeholder:string
  /**To set  value  to textbox */
  Value:any
  //** Set the MaxLength of characters In TextBox */
  MaxLength?:number
  /**Set the MinLength of characters In TextBox  */
  MinLength?:number
   //** Set the MaxWordCount of characters In TextBox */
   MaxWordCount: number;
  /** set Range Number to Textbox with type number with From-Value and To-value*/
  NumberRange:RangeNumber=new RangeNumber()
  /**Prevent AutoComplete of textbox*/
  AutoComplete:string="off"
  /**
  * Display "*" beside the label 
  * if ForceAsterisk=true and IsRequired=True his display "*" ,
  * if ForceAsterisk=false and IsRequired=false this remove "*",
  *if ForceAsterisk=false and IsRequired=True this display "*" , 
   */ 
  ShowAsterisk: boolean
  /** Ability to set  TextBox required */
  IsRequired: boolean
  /** Ability to display or hide the label of TextBox */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
  /**  text input on change  */ 
  TrimTextOnChange: boolean
  /** add button to for coping to clipboard */
  EnableCopyToClipboard: boolean
  /**Prevent  Defulat Password Validation to set Custom Validation */
  RemoveDefaultPasswordValidation:boolean
  /**  to set type of view  if textbox is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
  CustomValidation: CustomValidation[]=[]
  /** to set Direction of textbox  if textbox is Arabic or English  */
  ForceDirection: ForceDirection=ForceDirection.English
  /** Set Type of TextBox ("text","password","email","number") */
  Type: InputType
  /** Set List of Custom Attribute to TextBox  */
  AttributeList:Attribute[]
  /** Set Mask Pattern Attribute to TextBox  */
  MaskPattern:string
  



}